import axios from 'axios'
import {CONFIG} from '@/config/config'

export default {
  state: {
    loaded: false,
    login: null,
    uuid: null,
    nome: null,
    cpf: null,
    fotoUrl: null,
    pfId: null,
    oid: null,
    oeid: null,
    superUsuario: false,
    orgaoEntidade: {
      orgao: null,
      entidade: null,
      tipo: null
    }
  },
  mutations: {
    loadOrgaoData (state, orgaoData) {
      state.orgaoEntidade.orgao = orgaoData['orgao']
      state.orgaoEntidade.entidade = orgaoData['entidade']
      state.orgaoEntidade.tipo = orgaoData['tipo']
    },
    loadUserPfId(state, pf_id){
      state.pfId = pf_id
    },
    loadUserData (state, userData) {
      try {
        if (state.oeid !== userData['oeid']) {
          this.dispatch('loadOrgaoUsuarioInfo', {oid: userData['oid'], oeid: userData['oeid']})
        }

        state.login = userData['login']
        state.uuid = userData['uuid']
        state.nome = userData['nome']
        state.cpf = userData['login']
        state.fotoUrl = userData['foto']
        state.pfId = userData['pfid']
        state.oid = userData['oid']
        state.oeid = userData['oeid']
        state.superUsuario = (userData['superUsuario'] === 'S')
        state.loaded = true
      } catch (e) {
        console.error(`Falha ao carregar dados do usuário logado: ${e.toString()}`)
      }
    }
  },
  actions: {
    loadUserDataFromToken: async (context, token) => {
      try {
        if (token !== '') {
          var splitToken = token.split('.')
          if (splitToken.length > 1) {
            var tokenData = JSON.parse(window.atob(splitToken[1]))
            if ('user' in tokenData['data']) {
              return context.commit('loadUserData', tokenData['data']['user'])
            }
          }
        }
      } catch (e) {
        console.info(`Token inválido/inexistente: "+ ${e.toString()}`)
      }
    },
    loadOrgaoUsuarioInfo: async (context, ids) => {

    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js